import script from "./Inbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Inbox.vue?vue&type=script&setup=true&lang=js"

import "./Inbox.vue?vue&type=style&index=0&id=a0137468&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0137468"]])

export default __exports__